import type { CreateTweetJsonBodyMediaItemType } from './createTweetJsonBodyMediaItemType';

export type CreateTweetJsonBodyMediaItem = {
  id: string;
  type: CreateTweetJsonBodyMediaItemType;
  url: string;
};
